<template>
  <div>
    <div class="common_tab">
      <div class="common_go" @click="back">
        <img src="../assets/icon/navigation1.png" alt>
      </div>
      <div class="common_center">{{titleText}}</div>
      <div class="common_img" @click="jump" v-if="calendar == true">
        <img src="../assets/icon/_20190508162321.png" alt>
      </div>
      <div class="button" @click="buttonAdd" v-if="buttonState == true">清空</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from 'vant'; 
export default {
  props: {
    titleText: String,
    calendar: Boolean,
    buttonState: Boolean
  },
  data() {
    return {
      // title: this.titleText,
      // calendar: this.calendar
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    jump() {
      this.$router.push("./search");
    },
    buttonAdd() {
      Dialog.confirm({
        title: "提示",
        message: "是否清空历史记录",
        confirmButtonColor:'#fe8774',
        closeOnClickOverlay:"true",
        lockScroll:"true",
      })
        .then(() => {
          // on confirm
          Toast('已清空');
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style scoped lang="less">
.common_tab {
  width: 100%;
  height: 0.9rem;
  position: fixed;
  z-index: 999;
  border-bottom: 1px solid #d9d8dd;
  background: #ffffff;
  .common_go {
    width: 0.8rem;
    height: 0.8rem;
    position: absolute;
    img {
      width: 50%;
      height: 50%;
      margin-left: 0.1rem;
      margin-top: 0.24rem;
    }
  }
  .common_center {
    color: #323643;
    font-size: 0.33rem;
    text-align: center;
    line-height: 0.9rem;
    letter-spacing: 1px;
  }
  .common_img {
    width: 0.8rem;
    height: 0.8rem;
    position: absolute;
    right: 0;
    top: 0;
    img {
      width: 60%;
      height: 60%;
      margin-left: 0.1rem;
      margin-top: 0.24rem;
    }
  }
  .button {
    width: 0.8rem;
    height: 0.9rem;
    position: absolute;
    right: 0;
    top: 0;
    line-height: 0.9rem;
    color: #fe8774;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/topbar.vue